import React from 'react'
import { Tag } from "primereact/tag"
import { User } from "types/user"

interface StatusBadgesProps {
  data: User
}

const StatusBadges: React.FC<StatusBadgesProps> = ({data}) => {
  return (  <>
    {data.userVerifyPhoto && data.userVerifyPhoto.approved_by ?
      <div><Tag value="Verified" severity="success" className="m-1"/> </div> : <div> <Tag  value="Pending Verify" severity="warning" className="m-1"/> </div>}
    {data.userPhotos && data.userPhotos.some(y => !y.approvedAt) ?
      <div><Tag value="Pending Photo Approval" severity="warning" className="m-1"/></div> :  <div><Tag  value="Photos Approved" severity="success" className="m-1" /></div>}
    {data && !!data.approvedAt ?
      <div> <Tag value="User Approved" severity="success" className="m-1"/> </div>:
      data.deniedAt
        ? <div><Tag value="Denied User Approval" severity="danger" className="m-1"/></div>:
        !data.isBanned
        ? <div><Tag  value="Pending User Review" severity="warning" className="m-1"/></div>
        : <></>
    }
    {(data && data.activePurchases && data.activePurchases.length > 0) &&
      <div><Tag value="Premium" severity="info" className="m-1"/></div>}
    {data && data.isBanned &&
      <div><Tag value="Banned" severity="danger" className="m-1"/></div>}
    {}
  </>)
}

export default StatusBadges